import { useEffect, useRef } from 'react';
import { prefersReducedMotion } from '../lib/motion.ts';
import { buildHero } from '../three/hero.ts';
import { createStage } from '../three/stage.ts';

/** The only WebGL surface on the page. If the context cannot be had, the host
 *  keeps its CSS fallback and the hero is simply quieter — nothing below it
 *  depends on this rendering. */
export function HeroField() {
  const host = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = host.current;
    if (!element) return;

    const stage = createStage(element, { still: prefersReducedMotion() });
    if (!stage) return;

    buildHero(stage);
    return () => stage.dispose();
  }, []);

  return <div className="iso-scene" ref={host} aria-hidden="true" />;
}
